var _polygon, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconZoomIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "167.65 44.76 149.15 44.76 149.15 88.16 105.75 88.16 105.75 106.43 149.15 106.43 149.15 150.16 167.64 150.16 167.64 106.43 211.04 106.43 211.04 88.16 167.65 88.16 167.65 44.76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.4,0a97.39,97.39,0,0,0-74,160.83L74.3,171,63.67,160.35.16,224.2,32,256l63.5-63.84L84.88,181.57,95,171.43A97.44,97.44,0,1,0,158.4,0ZM31.94,234.77l-10.6-10.6,42.35-42.59,10.61,10.6ZM158.4,179.92a82.46,82.46,0,1,1,82.46-82.46A82.57,82.57,0,0,1,158.4,179.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoomIn);
export default __webpack_public_path__ + "static/media/icon-zoom-in.60ce3137.svg";
export { ForwardRef as ReactComponent };